export class StringUtil {
    static generateTemporaryToken(pId:number,qId:number,tId:number,terminalTypeId:number,lang:string) {
        return 'samp'+pId+'x'+qId+'x'+tId+'x'+terminalTypeId+'x'+lang;
    }

    static unixTimeStampToHumanReadable(tirtretme:(string|number)):string {
        if(typeof tirtretme === 'number') {
            return new Date(tirtretme).toString();
        }
        return new Date(Number(tirtretme)).toString();
    }

    static isEmptyOrNull(val:string) {
        return val == null || val === '';
    }

    static getSerial () {
        let text = '';
        const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

        for(let i = 0; i < 5; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }

        return text;
    }

    static stringHasExtension(val:string):boolean {
        const str = val.split('\\');
        if(StringUtil.checkForMediaTypes(str[str.length-1]) && str[str.length-1].split('.').length>0) {
            return true;
        }
        return false;
    }

    private static checkForMediaTypes(val:string) {
        const ext = ['jpg','gif','png'];

        for(const str of ext) {
            if(val.includes(str)) {
                return true;
            }
        }
        return false;
    }
}
